export const compId = localStorage.getItem("compId");
export const loggedInUserId = localStorage.getItem("userID");
export const loggedInUserRole = localStorage.getItem("role");
